import { Grid } from '@material-ui/core';
import { Alert, Typography, palette } from '@dev/ee-components';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { EXTENDED_LOGS_PRICE_PER_DAY } from '@/services/constants';
const StyledGrid = styled(Grid)`
    & .MuiAlert-root {
        margin-block: 20px;
        padding: 8px 16px;
        background: ${palette.gray[3]};
    }
`;

export const PurchaseExtendedLogsDialog: FC = (): JSX.Element => {
    const { t } = useTranslation();
    return (
        <StyledGrid container direction="column">
            <Typography variant="body1" bodyVariant="onPaper">
                {t('extendedlogsdesc')}
            </Typography>
            <Alert severity="info" body={t('extendedlogsinfoalert')} />
            <Typography variant="body1" bodyVariant="onPaper">
                {t('extendedlogsprice', { logsPrice: EXTENDED_LOGS_PRICE_PER_DAY })}
            </Typography>
        </StyledGrid>
    );
};
